// De DFM-contactpersoon van een bedrijfspagina.
//
// Een pagina draagt er twee: `data.contact` is de contactpersoon van de klant
// zelf, `data.account_manager` de accountmanager van DFM. Een medewerker ziet
// de eerste, iedereen daarboven de tweede. Die keuze stond in contactcard.vue
// en wordt nu gedeeld met het contactblok onder het Intakeformulieroverzicht --
// twee schermen die dezelfde persoon tonen horen hem niet elk apart op te
// zoeken.
//
// De kaart rendert ook op publieke routes, waar de pagina nog niet in de store
// staat: elk veld hieronder moet overleven dat `data` er niet is, en komt als
// string terug omdat de aanroepers erop filteren en `.includes()` doen.
//
// Bewust zonder imports: de standalone testscripts laden dit bestand via `vm`
// en strippen daar alleen `export` uit.

// Welke van de twee personen bij deze gebruiker hoort. `updating_role` wint,
// zodat een admin die een pagina namens iemand anders bekijkt ziet wat die
// ander ziet.
export function pageContactKey(user) {
  const role = user?.updating_role || user?.role;

  return role === "user" ? "contact" : "account_manager";
}

// `account_manager` komt uit de Teamleader- of Zoho-import, of de admin kiest
// hem uit de accountmanagers die de Zoho-import kent. Een pagina waar geen van
// beide gebeurde heeft een leeg object, en dan kreeg de werkgever een lege
// kaart. Dan liever `data.contact` dan niemand.
const isFilled = (person) =>
  Boolean(person?.name || person?.email || person?.phonenumber);

export function resolvePageContact(companypage, user) {
  const data = companypage?.data;
  const key = pageContactKey(user);
  const source =
    (key === "account_manager" && !isFilled(data?.account_manager)
      ? data?.contact
      : data?.[key]) || {};
  const address = source.address;

  return {
    name: source.name || "",
    phonenumber: source.phonenumber || "",
    email: source.email || "",
    profilepicture: source.profilepicture || "",
    address:
      address?.street && address?.city
        ? `${address.street} ${address.city}`
        : "",
  };
}

// De foto komt in drie smaken terug: een volledige URL, een bestandsnaam onder
// de contactmap van de CDN, of niets -- dan de standaardavatar.
export function contactPhotoUrl(profilepicture, cdnUrl) {
  const picture = typeof profilepicture === "string" ? profilepicture : "";

  if (picture.includes("http")) return picture;
  if (picture !== "") return `${cdnUrl}/pages/contacts/${picture}`;

  return `${cdnUrl}/default_images/default_avatar_image.png`;
}
